export const MODULE_NAME = 'tax';
export const ACCESS_NAME = 'Tax';
